module.exports = __webpack_public_path__ + "img/message-error.71ef2b89.png";